// MethodType values that are supported by the RPCService

export let MethodType = /*#__PURE__*/function (MethodType) {
  MethodType[MethodType["GET"] = 0] = "GET";
  MethodType[MethodType["POST"] = 1] = "POST";
  MethodType[MethodType["DELETE"] = 2] = "DELETE";
  MethodType[MethodType["PUT"] = 3] = "PUT";
  MethodType[MethodType["PATCH"] = 4] = "PATCH";
  return MethodType;
}({});
//# sourceMappingURL=MethodType.js.map
